import React, {useEffect, useState} from 'react';
import SliderViewCategories from './slider-view';
import ListViewCategories from './list-view';
import GridViewCategories from './grid-view/CategoryGrid';
import {useDispatch, useSelector} from 'react-redux';
import {Row, Col} from "antd";
import {getCategories} from 'redux/actions';
import CardSkeleton from "../../search/CardSkeleton";

function MenuCategories() {
    const skeleton = [0, 1, 2, 3, 4, 5];
    const {fetchedData: {categories, categoryLoading, storeData}, theme: {locale}} = useSelector(state => state);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCategories(
            'pickup' === localStorage.getItem('selected-mode') ?
                ('?branchId='+JSON.parse(localStorage.getItem('selected-branch'))?.id) : '' ));
    }, []);


    return (
        categoryLoading ? 
            <Row gutter={8} className="mx-3 my-4">
                 {skeleton.map(item => <Col lg={12} md={6} sm={8} xs={12} key={item}>
                     <CardSkeleton/>
                 </Col>)}
            </Row>    
        :
        <>
            {window.innerWidth < 992 ? 
                (storeData?.mobType === 'GRID'  ? <GridViewCategories/> :
                 storeData?.mobType === 'SLIDE' ? <SliderViewCategories/> : <ListViewCategories/>
                ) : 
                (storeData?.deskType === 'GRID' ? <GridViewCategories/> : <ListViewCategories/>) 
            }
        </> 
    );
}

export default MenuCategories;
